import { render, staticRenderFns } from "./Schmerzkurve.vue?vue&type=template&id=bf784916&scoped=true&"
import script from "./Schmerzkurve.vue?vue&type=script&lang=js&"
export * from "./Schmerzkurve.vue?vue&type=script&lang=js&"
import style0 from "./Schmerzkurve.vue?vue&type=style&index=0&id=bf784916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf784916",
  null
  
)

export default component.exports